import { gql } from '@apollo/client';
import { SourceType } from '../../../../components/WaterService/SourceTypePicker';
import { WaterSiteType } from '../../../../components/WaterSite/WaterSiteTypePicker';

export const GET_WATER_SITE_IDS = gql`
  query GetWaterSiteIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterSites(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`;

export const GET_WATER_SITES = gql`
  query GetWaterSites(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterSites(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      name
      siteNumber
      type
      lastSurveyDate
      nextSurveyDate
      surveyIntervalYears
      lastInspectionDate
      nextInspectionDate
      contact {
        id
        name
        firstName
        lastName
      }
      supervisor {
        id
        name
        firstName
        lastName
      }
      assignedTo {
        id
        name
        firstName
        lastName
      }
      address(required: true) {
        street1
        street2
        city
        state
        zip
        zipExt
      }
    }
  }
`;

type SiteContact = {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
};

export type WaterSiteItem = {
  id: string;
  name: string;
  type: WaterSiteType;
  lastSurveyDate?: string;
  nextSurveyDate?: string;
  surveyIntervalYears: number;
  lastInspectionDate?: string;
  nextInspectionDate?: string;
  contact: SiteContact;
  supervisor: SiteContact;
  assignedTo: SiteContact;
  address: {
    street1: string;
    street2?: string;
    city: string;
    state: string;
    zip: string;
    zipExt?: string;
  };
};
